"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_AUDIO_NORMALIZATION_ORDER = void 0;
const enums_1 = require("../enums");
exports.DEFAULT_AUDIO_NORMALIZATION_ORDER = enums_1.AudioNormalizationOrder.FinalVideo;
//# sourceMappingURL=clip-config.js.map